// extracted by mini-css-extract-plugin
export default {"root":"vXTdbN","disabled":"ky4pKR"};